import {Component, Injector} from '@angular/core';
import {WidgetDataControllerComponent} from '../../../../Controller/widget-data-controller-component';
import {ApiResponse} from '../../../../../Services/Api/base-api.service';
import {TransfersApiService} from '../../../../../Services/Api/Warehouse/Transfers/transfers-api.service';
import {TransferDto} from '../../../../../Models/Warehouse/Transfers/transfer.interface';
import {TransferStatusEnum} from '../../../../../Shared/Enum/transfer-status.enum';
import {TransferFilters} from '../../../../../Models/Warehouse/Transfers/transfer-filters.model';

@Component({
  selector: 'app-pendents-transfers-widget',
  templateUrl: './pendents-transfers-widget.component.html',
  styleUrls: ['./pendents-transfers-widget.component.scss'],
  standalone: false
})
export class PendentsTransfersWidgetComponent extends WidgetDataControllerComponent<number> {

  override fakeData: number = 6;

  get widgetData(): number {
    return this.data || this.data === 0 ? this.data : this.fakeData;
  }

  constructor(
    protected override injector: Injector,
    protected transfersService: TransfersApiService,
  ) {
    super(injector, transfersService);
  }


  /**
   * Obtener los traspasos pendientes
   *
   */
  override setData(data: TransferDto[]) {
    const localFilter: number = this.widgetsManager.filters?.local.id || 0;

    if (localFilter) {
      data = data.filter((item) => item.id_local === localFilter || item.id_local_destino === localFilter);
    }

    this.data = data.filter((item) => item.id_estado === TransferStatusEnum.sent)?.length;
  }


  /**
   * Obtener datos
   *
   */
  getData(): Promise<ApiResponse> {
    const transferFilters: TransferFilters = new TransferFilters({
      dias_atras: 30,
    });

    return this.transfersService.getTransfers(transferFilters);
  }

}
